import { SiteCsv } from "src/services/assessment/types/siteCsv";
import {
  assessmentFromAPIStatus,
  THIRTY_MINUTES_IN_SECONDS,
} from "src/jobRotationAssessment/constants/jobRotationConstants";
import { JobRotationAssessment } from "src/store/jobRotationAssessmentLibrarySlice";
export interface ValiditableObject {
  [key: string]: string | number;
}
export const getUserAssessmentSite = (
  data: SiteCsv[],
  selectedSite: string
): SiteCsv => {
  const assessmentSite = data.find((d) => d.site === selectedSite) || data[0];
  return assessmentSite;
};
export const getCurrentAssessmentSite = (
  sites: string[],
  homeSite: string
): string => {
  return sites.find((site) => site === homeSite) || sites[0];
};
export const getUpdatedAssessmentStatus = (
  status: string,
  dateCreated: string
) => {
  const startTimestamp = new Date(dateCreated).getTime() / 1000;
  const endTimestamp = new Date().getTime() / 1000;
  const timeDiff = endTimestamp - startTimestamp;
  if (
    status === assessmentFromAPIStatus.PROCESSING &&
    timeDiff > THIRTY_MINUTES_IN_SECONDS
  ) {
    return assessmentFromAPIStatus.ERROR;
  } else {
    return status;
  }
};
export const formatVideoTime = (time: number, millSecondRequired?: boolean) => {
  const minutesString = String(Math.floor(time / 60)).padStart(2, "0");
  const secondsString = String(Math.floor(time % 60)).padStart(2, "0");
  const millisecondsString = String(Math.floor((time % 1) * 100)).padStart(
    2,
    "0"
  );
  return `${minutesString}:${secondsString}${
    millSecondRequired ? `.${millisecondsString}` : ""
  }`;
};
export const isObjectCompleteWithValidValues = (
  objectToCheck: ValiditableObject,
  initialObject: ValiditableObject
): boolean => {
  const requiredKeys = Object.keys(initialObject);
  const isCompleteAndValid = requiredKeys.every(
    (key) => objectToCheck[key] !== undefined && objectToCheck[key] !== ""
  );
  return isCompleteAndValid;
};
export const isNonNegativeIntiger = (value: string): boolean => {
  return Number.isInteger(Number(value)) && Number(value) >= 0;
};
export const downloadCsv = (fileName: string, csv: string) => {
  const BOM = "\uFEFF";
  const blob = new Blob([BOM + csv], { type: "text/csv;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  try {
    const a = document.createElement("a");
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    a.remove();
  } finally {
    setTimeout(() => URL.revokeObjectURL(url), 0);
  }
};
export const buildMatrixCsvByComplementaryJobs = (
  assessments: JobRotationAssessment[]
) => {
  const assessmentNames = assessments.map(
    (assessment) => assessment.assessmentName
  );
  const complementaryJobsMapByName = new Map<string, string[]>(
    assessments.map((a) => [
      a.assessmentName,
      a.complementaryJobs?.map((jobs) => jobs.assessmentName),
    ])
  );
  const matrix: (string | number)[][] = [];
  matrix.push(["", ...assessmentNames]);
  for (const rowName of assessmentNames) {
    const rowComplementaryJobs = complementaryJobsMapByName.get(rowName);
    const row: string[] = [rowName];
    for (const colName of assessmentNames) {
      row.push(rowComplementaryJobs?.includes(colName) ? "1" : "0");
    }
    matrix.push(row);
  }
  return matrix;
};
